import { apiUrl } from '@/config/api';
import { LAUNCH_EVENTS } from '@/utils/payments/launchOffer';

const ALLOWED = new Set(LAUNCH_EVENTS);

/** First-party counts only. No health text, ids, or page paths. */
export function recordLaunchEvent(event) {
  if (!ALLOWED.has(event)) return;
  const url = apiUrl('/api/payments/launch-metric');
  const body = JSON.stringify({ event });
  try {
    if (navigator.sendBeacon) {
      const blob = new Blob([body], { type: 'application/json' });
      if (navigator.sendBeacon(url, blob)) return;
    }
  } catch {
    /* fall through to fetch */
  }
  fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body,
    credentials: 'omit',
    keepalive: true,
  }).catch(() => {});
}
